import { useState } from "react";
import useVerifyOTP from "features/otp/hooks/useVerifyOtp";
import useGenerateOTP from "features/otp/hooks/useGenerateOtp";
import { OTPFormData, OTPFormProps } from "../OtpForm.types";
import { useToast } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";

export default function useOtpForm({ onOTPCodeValidated, action, actionArgs = [], onSuccess, onError }: OTPFormProps) {
    const { showToast } = useToast();
    const translate = useTranslate();
    const [isValidatingOtp, setIsValidatingOtp] = useState<boolean>(false);
    const [isValidateButtonTriggered, setIsValidateButtonTriggered] = useState<boolean>(false);

    const { mutate: generateOTP } = useGenerateOTP();
    const { mutate: verifyOTP, reset } = useVerifyOTP({ onError: () => setIsValidatingOtp(false) });

    const [code, setCode] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);

    function handleSubmit({ code }: OTPFormData) {
        setIsValidateButtonTriggered(true);
        setIsValidatingOtp(true);
        verifyOTP(
            { code },
            {
                onSuccess(data) {
                    if (data.verified) {
                        onOTPCodeValidated?.(code);
                        if (action) {
                            triggerArgsFunction();
                        }
                    } else {
                        setIsValidatingOtp(false);
                        showToast(translate("invalidOTPCodeText"), { type: "error" });
                    }
                },
            },
        );
    }

    function triggerArgsFunction() {
        try {
            action?.(...actionArgs);
            onSuccess?.();
        } catch (error) {
            onError?.(error);
        }
    }

    function handleRegenerateOTP() {
        setCode("");
        generateOTP();
    }

    function onClose() {
        reset();
        setIsError(false);
    }

    return { code, setCode, isValidatingOtp, handleSubmit, handleRegenerateOTP, isError, onClose, isValidateButtonTriggered };
}
